import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import "./index.css";
import App from "./App";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "bootstrap/dist/css/bootstrap.css";

import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter } from "react-router-dom";
import { Provider, useDispatch, useSelector } from "react-redux";
import "./i18n";

import ErrorFallbackComponent from "./pages/ErrorFallback/ErrorFallback";
import {
  getCitiesOptions,
  getEmiratesOptions,
  getStatusOptions,
  setLanguage,
  getSystems,
  getServiceTerritories,
  getOnHoldReasons,
  getCDUCities,
  setConsolidatedInvoiceStatusOptions
} from "./redux/slices/lookupSlice";

import { getBMCProfile } from "./redux/slices/bMCProfileSlice";
import { getBMCList } from "./redux/slices/civilDefenseSlice";

import "./GilroyFont.css";
import "./UniversNextArabic.css";
import "react-toastify/dist/ReactToastify.min.css";
import cookies from "js-cookie";
import { CONSOLIDATED_PAYMENT_OPTIONS, devLocationOrigin, LANGuAGE_COOKIE } from "./resources/constant";
import { store } from "./redux/store";
import { LoadingIndicator } from "./components/loadingIndiactor/loadingIndiactor";
import { isCivilDefenseUser } from "./utils/helpers";
const Index = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state: any) => state.bMCProfile.token);
  useEffect(() => {
    // get app lookups with basic auth
    dispatch(getEmiratesOptions() as any);
    dispatch(getCitiesOptions("bbfaefd1-1f21-e811-910c-00505686c522") as any); // the default emirate id
    dispatch(setLanguage(cookies.get(LANGuAGE_COOKIE)));
    dispatch(setConsolidatedInvoiceStatusOptions(CONSOLIDATED_PAYMENT_OPTIONS) as any);
  }, [dispatch]);
  useEffect(() => {
    // get app lookups with cookie auth
    if (
      (isLoggedIn && isLoggedIn !== "local") ||
      (window.location.origin === devLocationOrigin && isLoggedIn === "local")
    ) {
      dispatch(getBMCProfile() as any);
      dispatch(getOnHoldReasons() as any);
      dispatch(getServiceTerritories(false, "") as any);
      dispatch(getSystems() as any);
      dispatch(getStatusOptions() as any);
      if (isCivilDefenseUser()) {
        dispatch(getBMCList() as any);
        dispatch(getCDUCities() as any);
      }
    }
  }, [dispatch, isLoggedIn]);

  let persistor = persistStore(store);
  return (
    <ErrorBoundary
      fallbackRender={(props) => <ErrorFallbackComponent {...props} />}
    >
      <BrowserRouter>
        <PrimeReactProvider>
          <PersistGate persistor={persistor} loading={<LoadingIndicator />}>
            <App />
          </PersistGate>
        </PrimeReactProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

const roots = document.querySelectorAll("#root");

roots.forEach((root) => {
  const roots = ReactDOM.createRoot(root);
  roots.render(
    <Provider store={store}>
      <React.StrictMode>
        <Index />
      </React.StrictMode>
    </Provider>
  );
});
